<!--
     <IndicatorMetrics
       :metrics="risk_metrics"
     />
-->

<template>
  <div class="inme-cont">
    <v-expansion-panels
      class="inme-expansion-panels-cont"
      v-model="panel"
      accordion
    >
      <v-expansion-panel
        v-for="metric, index in metrics"
        :key="metric.id"
        class="inme-expansion-panel"
      >
        <v-expansion-panel-header>
          {{ metric.name }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>

          <div class="inme-expanded">

            <!-- Categorical -->
            <div
              class="inme-categorical"
              v-if="metric.type == 'category'"
            >
              <div class="inme-cattable">
                <div
                  v-for="[cat, val], ix in category_iter[index]"
                  :key="ix"
                >
                  <div class="inme-ctpos">{{ ix+1 }}</div>
                  <div class="inme-cttxt">{{ cat }}</div>
                  <div class="inme-ctval">{{ val }}</div>
                </div>
              </div>
              <p>
                {{ metric.metric_config.description }}
              </p>
            </div>

            <!-- Numeric -->
            <div
              class="inme-numeric"
              v-if="metric.type == 'number'"
            >
              <p class="inme">
                <span>{{ $t('indicator.numbers') }}</span>
                <span>{{ $t('indicator.'+metric.metric_config.number_type) }}</span>
                <span v-if="metric.metric_config.only_positive">{{ $t('indicator.positive') }}</span>
              </p>
              <p class="inme">
                <span>{{ $t('indicator.units')+':' }}</span><span>{{ metric.metric_config.units }}</span>
              </p>
              <p class="inme">
                {{ metric.metric_config.description }}
              </p>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>


<style lang="scss">
 @import "@/sass/variables.scss";

 .inme-cont {
   min-width: 180px;
   max-width: 480px;
 }

 .inme-expansion-panel {
   background-color: #fafafa !important;
 }

 .inme-expanded {
   padding-left: 0px;
   font-family: $font;
   font-size: 14px;
 }

 .inme-numeric {
   display: flex;
   flex-direction: column;
   flex-wrap: no-wrap;
 }

 p.inme > span::after {
   content: ' ';
 }

 .inme-cattable {
   display: flex;
   flex-direction: column;
 }

 .inme-cattable > div {
   display: flex;
   flex-direction: row;
   gap: 24px;
   border-style: solid;
   border-color: #cacaca;
   border-width: 0px 0px 1px 0px;
   max-width: 320px;
 }

 .inme-ctpos {
   width: 32px;
   text-align: right;
 }
 .inme-cttxt {
   width: 100%;
 }
 .inme-ctval {
   width: 128px;
   text-align: right;
 }
</style>


<script>
 export default {
   name: 'IndicatorMetrics',

   props: {
     metrics: {required: true},
   },

   components: {
   },

   data: (() => ({
     panel: null,
   })),

   mounted() {
     this.panel = null;
   },

   computed: {
     category_iter() {
       // Returns an array of all metrics with null if no category
       // Returns an iterator that yields [cat, value] for a given category
       // Example: [null, Iterator[cat, val], null, ...]
       return this.metrics.map(
         m => ((m.type === 'category') ? Object.entries(m.metric_config.categories) : null)
       );
     },
   },

   methods: {
     
   },
 }
</script>
